import {
  ConflictReasonDto,
  DefinitionEventKindDto,
  PlannedChangeKindDto,
  SurveyGapCodeDto,
  VersionStatusDto,
} from '@/api/generated';
import { ComponentsTranslation } from '@/assets/locales/components/components.translation.en.ts';
import { PolishPlurals } from '@/assets/locales/PolishPlurals.model.ts';
import { StatusActionEnum } from '@/models/status/StatusAction.enum.ts';

export const componentsTranslation: PolishPlurals<ComponentsTranslation> = {
  confirmDialog: {
    cancel: 'Anuluj',
  },
  conflict: {
    reasons: {
      [ConflictReasonDto.AlreadyInvalidated]: 'To podejście zostało już unieważnione.',
      [ConflictReasonDto.AlreadyPassed]:
        'Ten test jest już zaliczony, więc kolejne podejście nie jest możliwe.',
      [ConflictReasonDto.AnonymityFixed]:
        'Ankieta ma już odpowiedzi, więc nie można zmienić anonimowości.',
      [ConflictReasonDto.AttemptInProgress]:
        'To podejście jeszcze trwa. Wynik będzie dostępny po jego zakończeniu.',
      [ConflictReasonDto.AttemptLimitReached]:
        'Wykorzystano już wszystkie podejścia do tego testu.',
      [ConflictReasonDto.AttemptOver]:
        'To podejście już się zakończyło albo skończył się jego czas.',
      [ConflictReasonDto.Clash]:
        'Ktoś zmienił te dane w międzyczasie. Odśwież stronę i spróbuj ponownie.',
      [ConflictReasonDto.ConfirmationRequired]:
        'Ta zmiana obejmuje wiele pytań i wymaga potwierdzenia. Potwierdź ją i spróbuj ponownie.',
      [ConflictReasonDto.ExaminerRequired]:
        'Ten test wymaga oceny egzaminatora, więc nie można go jeszcze rozpocząć.',
      [ConflictReasonDto.GoingBackNotAllowed]:
        'W tym teście nie można wrócić do wcześniejszych pytań.',
      [ConflictReasonDto.InUse]: 'Nie można tego usunąć, bo jest w użyciu.',
      [ConflictReasonDto.KeyTaken]: 'Ten klucz pytania jest już zajęty. Wpisz inny.',
      [ConflictReasonDto.MaterialInForce]:
        'Nie można usunąć odpowiedzi z materiałem w aktywnej wersji. Aby ją usunąć, utwórz nową wersję pytania.',
      [ConflictReasonDto.MissingRequired]:
        'Aby wysłać ankietę, odpowiedz na wszystkie pytania obowiązkowe.',
      [ConflictReasonDto.NameTaken]: 'Ta nazwa jest już zajęta. Wpisz inną.',
      [ConflictReasonDto.NeverInUse]:
        'Szkicu nie można wyłączyć. Jeśli nie jest potrzebny, usuń go.',
      [ConflictReasonDto.NotAnExam]: 'Egzaminator prowadzi tylko egzamin praktyczny.',
      [ConflictReasonDto.NotReady]: 'Czegoś jeszcze brakuje. Uzupełnij braki i spróbuj ponownie.',
      [ConflictReasonDto.PersonLocked]: 'Podejścia tej osoby do tego testu są zablokowane.',
      [ConflictReasonDto.PrefixInUse]:
        'Prefiksu nie można zmienić, bo powstały już z niego klucze pytań.',
      [ConflictReasonDto.PrefixTaken]: 'Ten prefiks ma już inna kategoria. Wpisz inny.',
      [ConflictReasonDto.ResponseOver]: 'Ta ankieta została już wysłana albo odrzucona.',
      [ConflictReasonDto.SurveyNotActive]:
        'Ta ankieta nie jest aktywna, więc nie można jej uruchomić.',
      [ConflictReasonDto.TestNotActive]: 'Ten test nie jest aktywny, więc nie można go rozpocząć.',
      [ConflictReasonDto.Unanswered]: 'Aby zakończyć test, odpowiedz na wszystkie pytania.',
      [ConflictReasonDto.Ungraded]: 'Aby zakończyć egzamin, oceń wszystkie pytania.',
      [ConflictReasonDto.VersionStatus]: 'Status tej wersji pytania nie pozwala na tę zmianę.',
    },
    unknown: 'Nie udało się zapisać, bo stan danych na to nie pozwala.',
  },
  dataTable: {
    displayedRows: '{{from}}–{{to}} z {{count}}',
    loadingLabel: 'Wczytywanie wierszy',
    rowsPerPage: 'Wierszy na stronie',
    sortAscending: 'sortowanie rosnąco',
    sortDescending: 'sortowanie malejąco',
  },
  definitionHistory: {
    after: 'Po',
    before: 'Przed',
    description: 'Zmiany od najnowszej, każda z autorem i czasem.',
    empty: 'Nic się jeszcze nie zmieniło.',
    eventMeta: '{{date}}, {{author}}',
    events: {
      [DefinitionEventKindDto.Changed]: 'Zmieniono',
      [DefinitionEventKindDto.Created]: 'Utworzono',
      [DefinitionEventKindDto.StatusChanged]: 'Zmieniono status',
    },
    otherField: 'Inna zmiana',
    title: 'Historia zmian',
    values: {
      added: 'Dodano',
      no: 'nie',
      none: 'brak',
      removed: 'Usunięto',
      yes: 'tak',
    },
  },
  emptyState: {
    noData: {
      description: 'Dodane pozycje pojawią się w tym miejscu.',
      title: 'Nic tu jeszcze nie ma',
    },
    noMatch: {
      clearFilters: 'Wyczyść filtry',
      description: 'Zmień wyszukiwaną frazę albo wyczyść filtry, aby zobaczyć więcej wyników.',
      title: 'Brak pasujących wyników',
    },
  },
  errorState: {
    description: 'Nie udało się wczytać danych. Sprawdź połączenie i spróbuj ponownie.',
    retry: 'Spróbuj ponownie',
    title: 'Coś poszło nie tak',
  },
  form: {
    characterCount: '{{length}} / {{max}}',
    fieldRejected: 'Sprawdź to pole.',
    forbidden: 'Nie masz uprawnień do zapisania tych zmian.',
    requiredMark: 'wymagane',
    serverRejected: 'Niektóre pola wymagają poprawy. Popraw je i zapisz ponownie.',
    unexpectedError: 'Nie udało się zapisać zmian. Spróbuj ponownie.',
  },
  loadingState: {
    label: 'Wczytywanie',
  },
  mediaPreview: {
    close: 'Zamknij powiększenie',
    enlarge: 'Powiększ zdjęcie',
    imageAlt: 'Materiał: {{name}}',
    imageAltUnnamed: 'Ilustracja do pytania',
    loadFailed: 'Nie udało się wczytać materiału.',
    retry: 'Wczytaj ponownie',
    viewerLabel: 'Powiększone zdjęcie',
  },
  mutationFeedback: {
    forbidden: 'Nie masz uprawnień do tej operacji.',
  },
  notifications: {
    close: 'Zamknij powiadomienie',
  },
  positionSelect: {
    loading: 'Wczytywanie stanowisk',
    noOptions: 'Brak pasujących stanowisk',
    outdated: '{{label}} (nieaktualne)',
    unavailable: 'Nie udało się wczytać stanowisk. Odśwież stronę.',
  },
  questionImpact: {
    affected: {
      description: 'Mimo to możesz kontynuować. Potem dodaj brakujące pytania.',
      title: 'Aktywnym testom lub ankietom zabraknie pytań',
    },
    cancel: 'Anuluj',
    checking: 'Sprawdzanie, czy zmiana dotyczy aktywnych testów i ankiet',
    error: {
      description: 'Spróbuj ponownie albo kontynuuj bez tej informacji.',
      retry: 'Spróbuj ponownie',
      title: 'Nie udało się sprawdzić, czy zmiana dotyczy aktywnych testów i ankiet',
    },
    none: {
      [PlannedChangeKindDto.ActivateVersion]:
        'Po aktywacji tej wersji aktywnym testom i ankietom nadal wystarczy pytań.',
      [PlannedChangeKindDto.Retire]:
        'Po wyłączeniu aktywnym testom i ankietom nadal wystarczy pytań.',
      [PlannedChangeKindDto.SetCategory]:
        'Po zmianie kategorii aktywnym testom i ankietom nadal wystarczy pytań.',
      [PlannedChangeKindDto.SetPositions]:
        'Po zmianie stanowisk aktywnym testom i ankietom nadal wystarczy pytań.',
    },
    noneAfterChanges: 'Po tych zmianach aktywnym testom i ankietom nadal wystarczy pytań.',
    part: 'Część {{number}}',
    position: 'stanowisko {{name}}',
    shortfall:
      '{{label}}: potrzeba {{needed}}, teraz dostępne {{available}}, po zmianie {{after}}.',
    surveyGaps: {
      [SurveyGapCodeDto.NoQuestions]: 'Ankieta zostanie bez pytań.',
      [SurveyGapCodeDto.QuestionNotInUse]: 'Pytanie {{key}} nie będzie miało aktywnej wersji.',
      [SurveyGapCodeDto.TranslationNotApproved]:
        'Pytanie {{key}} nie będzie miało zatwierdzonej treści.',
    },
    surveys: 'Ankiety',
    tests: 'Testy',
    unknownQuestion: 'z listy',
  },
  questionPresentation: {
    answerKey: 'Klucz odpowiedzi',
    answerMediaLabel: 'Materiały do odpowiedzi',
    answerPlaceholder: 'Wpisz odpowiedź',
    answerPoints: 'Punkty: {{points}}',
    answersLabel: 'Odpowiedzi',
    correct: 'Poprawna',
    emptyAnswer: 'Pusta odpowiedź',
    emptyBody: 'Tu pojawi się treść pytania.',
    examiner: {
      answerKey: 'Klucz dla egzaminatora',
      comment: 'Komentarz egzaminatora',
      commentPlaceholder: 'Zapisz, co wpłynęło na ocenę. Osoba egzaminowana tego nie zobaczy.',
      commentRequired: 'Komentarz egzaminatora (wymagany)',
      fail: 'Niezaliczone',
      pass: 'Zaliczone',
      points: 'Punkty',
      pointsHint: 'Od 0 do {{max}}, najwyżej jedno miejsce po przecinku.',
      result: 'Wynik',
      scale: 'Ocena od 0 do {{max}}',
      topicNumber: '{{number}}.',
      topics: 'Zagadnienia',
      topicsPicked: 'Zaznaczono {{picked}} z {{total}}',
      topicsToPick_few: 'Egzaminator wybiera {{count}} zagadnienia.',
      topicsToPick_many: 'Egzaminator wybiera {{count}} zagadnień.',
      topicsToPick_one: 'Egzaminator wybiera {{count}} zagadnienie.',
    },
    expectedAnswers: 'Oczekiwana odpowiedź',
    hiddenMarker: {
      [VersionStatusDto.Draft]: 'Tylko szkic, pracownik go nie widzi',
      [VersionStatusDto.Retired]: 'Wyłączone, pracownik go nie widzi',
    },
    missingTranslation:
      'To pytanie nie ma zatwierdzonej treści w tym języku, więc nie pojawi się w teście w tym języku.',
    noVersion: 'Pytanie nie ma jeszcze wersji do pokazania.',
    openPlaceholder: 'Napisz odpowiedź',
    ordering: {
      correctPosition: 'Właściwe miejsce: {{position}}',
      hint: 'Przeciągnij odpowiedzi albo użyj strzałek, aby ułożyć je w kolejności.',
      moveDown: 'Przesuń niżej: {{answer}}',
      moveUp: 'Przesuń wyżej: {{answer}}',
    },
    questionMediaLabel: 'Materiały do pytania',
    showCorrect: 'Pokaż poprawne odpowiedzi',
    solution: {
      explanation: 'Wyjaśnienie',
      maxPoints: 'Punkty za pytanie',
    },
    unapprovedMarker: 'Treść niezatwierdzona, pracownik jej nie widzi',
  },
  reasonDialog: {
    cancel: 'Anuluj',
    reason: 'Powód',
    reasonPlaceholder: 'Opisz krótko, dlaczego.',
  },
  reviewMark: {
    clear: 'Zdejmij oznaczenie',
    dialog: {
      cancel: 'Anuluj',
      confirm: 'Oznacz do przeglądu',
      description:
        'Pytanie dostanie oznaczenie widoczne na liście, w pytaniu i w trybie przeglądu.',
      reason: 'Powód (opcjonalnie)',
      reasonPlaceholder: 'Na co zwrócić uwagę przy przeglądzie',
      title: 'Oznacz do przeglądu',
    },
    mark: 'Oznacz do przeglądu',
    markedBy: 'Oznaczenie: {{person}}, {{date}}',
    noReason: 'Bez podanego powodu.',
    notifications: {
      cleared: 'Zdjęto oznaczenie do przeglądu.',
      clearFailed: 'Nie udało się zdjąć oznaczenia. Spróbuj ponownie.',
      marked: 'Pytanie oznaczono do przeglądu.',
      markFailed: 'Nie udało się oznaczyć pytania. Spróbuj ponownie.',
    },
    title: 'Do przeglądu',
  },
  searchField: {
    clear: 'Wyczyść wyszukiwanie',
    minLength_few: 'Wpisz co najmniej {{count}} znaki.',
    minLength_many: 'Wpisz co najmniej {{count}} znaków.',
    minLength_one: 'Wpisz co najmniej {{count}} znak.',
    placeholder: 'Szukaj',
  },
  statusAction: {
    actions: {
      [StatusActionEnum.ACTIVATE]: 'Aktywuj',
      [StatusActionEnum.RESTORE]: 'Przywróć',
      [StatusActionEnum.RETIRE]: 'Wyłącz',
    },
    saveFirst: 'Najpierw zapisz zmiany.',
  },
  testPerson: {
    cannotStart: 'Nie może rozpocząć testu',
    canStart: 'Może rozpocząć test',
    fields: {
      granted: 'Przyznane dodatkowo',
      invalidated: 'Unieważnione',
      left: 'Pozostałe',
      limit: 'Limit',
      used: 'Wykorzystane',
    },
    forbidden: {
      description: 'Jeśli go potrzebujesz, poproś administratora o dostęp.',
      title: 'Nie masz dostępu do stanu tej osoby',
    },
    grants: {
      empty: 'Nie przyznano dodatkowych podejść.',
      meta: '{{date}} · Przez: {{by}}',
      title: 'Przyznane dodatkowe podejścia',
    },
    lock: {
      description: 'Zablokowano {{date}}. Przez: {{by}}. Powód: {{reason}}',
      title: 'Podejścia są zablokowane',
    },
    lockedAfterPass: 'Zamknięte po zaliczeniu',
    noLimit: 'Bez limitu',
    passed: 'Test zaliczony',
  },
  uploadField: {
    tooLarge: 'Plik jest za duży. Limit to {{maxFileSize}}.',
    tooManyFiles: 'Dodaj jeden plik naraz.',
    wrongFormat: 'Ten format pliku nie jest obsługiwany.',
  },
};
